export const AustralianStatesArray = () => {
	return [
		{
			id: "ACT",
			text: "Australian Capital Territory",
		},
		{
			id: "NSW",
			text: "New South Wales",
		},
		{
			id: "NT",
			text: "Northern Territory",
		},
		{
			id: "QLD",
			text: "Queensland",
		},
		{
			id: "SA",
			text: "South Australia",
		},
		{
			id: "TAS",
			text: "Tasmania",
		},
		{
			id: "VIC",
			text: "Victoria",
		},
		{
			id: "WA",
			text: "Western australia",
		}
	]
};
export default AustralianStatesArray();